import {
    BookingflowStateMachine,
} from '@raskrask-dk/bookingflow-state-machine'
import { ProductType, IPaymentPrice } from '@raskrask-dk/raskrask-utils'
import { v4 as uuidv4 } from 'uuid'

// https://www.partner-ads.com/dk/tracking_lead.txt

/**
 * NOTES ABOUT COOKIE SETTING AND READING:
 * - once a cookie is set, it can not be changed
 * - when setting the cookie, it is posible to set its domain, path and security settings
 * - paid and pacid cookies are set on ".raskrask.dk" with path "/".
 *  This should allow them to be read on all subdomains of "raskrask.dk" including "booking.raskrask.dk".
 *  Because they are set on ".raskrask.dk", when testing on localhost, we need to overwrite the domain of the cookie
 *  in the developer tools of the browser to "localhost" so they can be read here.
 *  Keep in mind that if we ever move the BF from a "raskrask.dk" sub-domain, this gonna stop working.
 */

const getCookie = (name: string): string | undefined => {
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim()
        if (cookie.startsWith(name + '=')) {
            return cookie.substring(name.length + 1)
        }
    }
    return
}

export const submitAffiliatesTracking = async (
    BFSM: BookingflowStateMachine,
    productType: ProductType,
    paymentInfo?: IPaymentPrice,
    bookingId?: string
): Promise<void> => {
    try {
        const paid = getCookie('paid')
        const pacid = getCookie('pacid')

        if (
            productType === 'Package' ||
            paid === undefined ||
            pacid === undefined
        )
            return

        if (productType === 'Booking' && paymentInfo?.turnover !== undefined) {
            await BFSM.repo.submitPartnerAdsSale({
                paid: paid,
                pacid: pacid,
                ordernummer: `BF-Booking-${bookingId}`,
                omsaetningPRSalg: paymentInfo.turnover,
            })
        }

        if (productType === 'CompanyLead') {
            await BFSM.repo.submitPartnerAdsLead({
                paid: paid,
                pacid: pacid,
                ordernummer: `BF-CompanyLead-${uuidv4()}`,
            })
        }
    } catch (err) {
        return
    }
}
